"use client";

import { useEffect, useRef, useState } from "react";
import { ArrowRight, CalendarClock } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CategoryHero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    once: true,
    threshold: 0.15
  });
  const sneakerRef = useRef<HTMLImageElement | null>(null);
  const [offset, setOffset] = useState(0);
  useEffect(() => {
    const onScroll = () => {
      setOffset(window.scrollY * 0.18);
    };
    window.addEventListener("scroll", onScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  const marqueeItems = [{
    id: 1,
    text: "ACERO ESTRUCTURAL"
  }, {
    id: 2,
    text: "ACERO ESTRUCTURAL"
  }, {
    id: 3,
    text: "ACERO ESTRUCTURAL"
  }, {
    id: 4,
    text: "ACERO ESTRUCTURAL"
  }];
  return <section data-section-id="1980" id="category-hero" className="relative min-h-screen w-full overflow-hidden bg-background text-foreground">
      {}
      <div className="pointer-events-none absolute right-[-10%] top-1/2 h-[80vh] w-[80vh] -translate-y-1/2 rounded-lg blur-3xl" style={{
      background: "radial-gradient(circle, hsl(125 55% 24% / 0.15) 0%, hsl(125 55% 24% / 0.05) 40%, transparent 70%)"
    }} aria-hidden="true" />

      {}
      <div className="pointer-events-none absolute inset-0 flex items-center justify-center overflow-hidden" aria-hidden="true">
        <div className="flex -rotate-12 gap-10 opacity-[0.03] whitespace-nowrap">
          {marqueeItems.map((m, i) => <span key={m.id} data-index={i} className="font-default text-[12vw] font-bold uppercase leading-none tracking-tight">
              {m.text}
            </span>)}
        </div>
      </div>

      <div ref={ref} className="relative z-10 mx-auto flex min-h-screen max-w-7xl flex-col justify-center px-6 py-24 sm:px-8 lg:px-12">
        <div className="grid items-center gap-12 lg:grid-cols-12">
          {}
          <div className={`lg:col-span-8 transition-all duration-700 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
            <span className="mb-6 inline-block font-mono text-xs font-medium uppercase tracking-[0.35em] text-primary sm:text-sm">
              Líderes en la Industria
            </span>

            <h1 className="font-default font-bold uppercase tracking-tight text-foreground" style={{
            fontSize: "clamp(4rem, 12vw, 8rem)",
            lineHeight: 0.9
          }}>
              <span className="block">Kalisch</span>
              <span className="block text-primary">Acero</span>
            </h1>

            <p className="mt-6 max-w-md font-default text-base text-muted-foreground sm:text-lg">
              Soluciones integrales en acero para proyectos de gran escala. Calidad certificada y resistencia industrial garantizada.
            </p>

            <div className="mt-10 flex flex-col gap-4 sm:flex-row">
              <Button asChild size="lg" className="h-12 rounded-md bg-primary px-8 text-sm font-semibold uppercase tracking-wider text-primary-foreground hover:bg-primary-600 shadow-md">
                <Link to="/CatalogPage">
                  Ver Catálogo
                  <ArrowRight className="size-4" />
                </Link>
              </Button>

              <Button asChild size="lg" variant="outline" className="h-12 rounded-md border-border bg-transparent px-8 text-sm font-semibold uppercase tracking-wider text-foreground hover:bg-muted hover:text-foreground shadow-sm">
                <Link to="/ProductsPage">Nuestros Productos</Link>
              </Button>
            </div>
          </div>

          {}
          <div className="relative lg:col-span-4">
            <div className="relative mx-auto flex max-w-md items-center justify-center lg:max-w-none">
              {}
              <Badge className="absolute -top-2 left-2 z-20 flex flex-col items-start gap-0.5 rounded-md bg-card px-3 py-2 text-card-foreground shadow-lg sm:left-0 lg:-left-8 border border-border">
                <span className="flex items-center gap-1 font-mono text-[10px] uppercase tracking-widest text-primary">
                  <CalendarClock className="size-3" />
                  Disponibilidad
                </span>
                <span className="font-default text-sm font-bold">Stock Inmediato</span>
              </Badge>

              <img ref={sneakerRef} src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/kalisch_steel_structural_beam.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/kalisch_steel_structural_beam.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/kalisch_steel_structural_beam.png-wvc-sizes" alt="Viga de acero estructural Kalisch" loading="eager" decoding="async" className="w-full max-w-[34rem] -rotate-12 object-contain drop-shadow-[0_40px_50px_hsl(125_55%_24%/0.15)] lg:scale-[1.6] lg:translate-x-12" style={{
              transform: `translateY(${offset}px) rotate(-12deg)`
            }} />

              {}
              <div className="pointer-events-none absolute -bottom-6 left-1/2 h-8 w-3/4 -translate-x-1/2 rounded-md blur-2xl" style={{
              background: "hsl(0 0% 17% / 0.1)"
            }} aria-hidden="true" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}